import React from 'react';
import CrudManager from './CrudManager';
import { adminApi } from '../../lib/api';

const SERVICE_FIELDS = [
  { name: 'name', label: 'Service Name', required: true },
  { name: 'description', label: 'Description', type: 'textarea', required: true, rows: 3 },
  { name: 'features', label: 'Features', type: 'list' },
  {
    name: 'icon',
    label: 'Icon',
    help: 'Lucide React icon name (e.g. Camera, Aperture, Film, Video)',
    placeholder: 'Camera',
  },
  { name: 'order', label: 'Display Order', type: 'number' },
];

const ServicesAdmin = () => (
  <CrudManager
    title="Services"
    description="Services displayed on the homepage"
    api={adminApi.services}
    fields={SERVICE_FIELDS}
    itemLabel="Service"
    renderItem={(svc) => (
      <div>
        <h3 className="text-[#EADBC8] font-bold mb-1">{svc.name}</h3>
        <p className="text-gray-400 text-sm mb-2 line-clamp-2">{svc.description}</p>
        <p className="text-gray-500 text-xs">
          Icon: {svc.icon} · Order: {svc.order}
        </p>
      </div>
    )}
  />
);

export default ServicesAdmin;
